import React from "react";
import ReactDOM from "react-dom";
var hydrateRef;
var isFirstHydration = true;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export function onRouteUpdate() {
  if (process.env.NODE_ENV === "production" && isFirstHydration && // Safari has a bug that causes images to stay blank when directly loading a page (images load when client-side navigating)
  // running this code on first hydration makes images load.
  !isSafari) {
    isFirstHydration = false;
    return;
  }

  if ("requestIdleCallback" in window) {
    if (hydrateRef) {
      // @ts-ignore cancelIdleCallback is on window object
      cancelIdleCallback(hydrateRef);
    } // @ts-ignore requestIdleCallback is on window object


    hydrateRef = requestIdleCallback(hydrateImages);
  } else {
    if (hydrateRef) {
      clearTimeout(hydrateRef);
    }

    hydrateRef = setTimeout(hydrateImages);
  }
}

function hydrateImages() {
  var doc = document;
  var inlineWPimages = Array.from(doc.querySelectorAll("[data-wp-inline-image]"));

  if (!inlineWPimages.length) {
    return;
  }

  import(
  /* webpackChunkName: "gatsby-plugin-image" */
  "gatsby-plugin-image").then(function (mod) {
    inlineWPimages.forEach(function (image) {
      if (image.dataset && image.dataset.wpInlineImage && image.parentNode.parentNode) {
        var hydrationData = doc.querySelector("script[data-wp-inline-image-hydration=\"".concat(image.dataset.wpInlineImage, "\"]"));

        if (hydrationData) {
          var imageProps = JSON.parse(hydrationData.innerHTML); // @ts-ignore - createRoot is on ReactDOM

          if (ReactDOM.createRoot) {
            // @ts-ignore - createRoot is on ReactDOM
            var root = ReactDOM.createRoot(image.parentNode.parentNode); // @ts-ignore - not same as below, not sure why it's complaining

            root.render( /*#__PURE__*/React.createElement(mod.default, imageProps), {
              hydrate: true
            });
          } else {
            ReactDOM.hydrate(
            /*#__PURE__*/
            // @ts-ignore - no idea why it complains
            React.createElement(mod.GatsbyImage, imageProps), image.parentNode.parentNode);
          }
        }
      }
    });
  });
}